import { environment } from "../../../environments/environment";
import { FETCH_METHODS, SearchConfig } from "./api.model";
import { OptionsFetchConfig } from "./common.model";
import { DataTableSchema, DefaultTableSchema } from "./dynamic-data-table.model";
import { defaultSearchContainerButtons, DealerNumberDropdown, CertificationDropdown, IsPcDropdown, JobRoleDropdown, FieldNames, ElevateNewsletterDropdown, NonCertifiableRolesCheckbox, CertifiableRolesCheckbox, DropdownOptions, AreaDropdown, SpinIdNumber } from "./form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "./form.model";

export const DealerTrainingBillingBaseUrl = () => {
    return environment['dealerTrainingBilling'] ?? 'dealerTrainingBilling';
};

export const preSelectedCertifiableRoles = {
    "Admin": ["CASHIER", "BUSINESS OFFICE MANAGER", "OFFICE ADMINISTRATOR", "RECEPTIONIST"],
    "Body Shop": ["COLLISION CENTER MANAGER", "COLLISION REPAIR SPECIALIST", "DEALER BODY SHOP ESTIMATOR", "REFINISH SPECIALIST", "DETAIL SPECIALIST"],
    "Cust Service": ["CUSTOMER SATISFACTION MANAGER"],
    "Parts": ["PARTS MANAGER", "PARTS SPECIALIST"],
    "Sales": ["PRE-OWNED SALES MANAGER", "FINANCIAL SERVICES MANAGER", "SALES MANAGER", "PRE-OWNED SALES CONSULTANT", "SALES CONSULTANT", "LEXUS DELIVERY SPECIALIST", "SALES ADMINISTRATOR"],
    "Service": ["SERVICE CONSULTANT", "DIAGNOSTIC SPECIALIST", "SERVICE ADMINISTRATOR", "LEXUS TECHNOLOGY SPECIALIST", "SERVICE MANAGER", "VALET", "SERVICE & PARTS MANAGER", "SERVICE CASHIER", "SERVICE TECHNICIAN"]
}
export const preSelectedNonCertifiableRoles = {
    "ADMIN": ["ADMINISTRATION OTHER", "OFFICE ADMINISTRATOR", "SALES ADMINISTRATOR", "SERVICE ADMINISTRATOR", "TRAINING ADMINISTRATOR"],
    "BODY SHOP": ["BODY SHOP OTHER", "DEALER BODY SHOP ESTIMATOR"],
    "COLLISION": ["ASSISTANT COLLISION CENTER MGR", "COLLISION CTR OFFICE MANAGER", "COLLISION CUSTOMER SERVICE REP", "COLLISION MECHANICAL TECH"],
    "MANAGER": ["CREDIT MANAGER", "FLEET MANAGER", "GENERAL MANAGER", "GENERAL SALES MANAGER", "LEASING MANAGER", "PRODUCTION MANAGER", "WARRANTY MANAGER"],
    "OTHER": ["CONTROLLER", "CUSTOMER RELATIONS OTHER", "CUSTOMER SATISFACT. PERSONNEL", "DEALER PRINCIPAL", "INTERNET BUS DEVELOPMENT MGR", "OTHER", "PARTS DIRECTOR",
        "PARTS OTHER", "PRE-OWNED SALES CONSULTANT", "SALES CONSULTANT", "SALES OTHER", "WARRANTY PERSONNEL"],
    "SERVICE": ["SERVICE ASSISTANT", "SERVICE DIRECTOR", "SERVICE DISPATCHER", "SERVICE OTHER"]
}


const FormFieldArray: FormFieldConfig[] = structuredClone([SpinIdNumber,AreaDropdown, { ...structuredClone(DealerNumberDropdown), displayName: 'Dealer' }, CertificationDropdown,
    IsPcDropdown, { ...structuredClone(JobRoleDropdown), options: DropdownOptions[FieldNames['JobRole']], multiple: true, defaultValue: ['Primary', 'Secondary'] }, ElevateNewsletterDropdown,
    { ...structuredClone(CertifiableRolesCheckbox), preSelectedValues: preSelectedCertifiableRoles, isLoading: true, hidden: true },
    { ...structuredClone(NonCertifiableRolesCheckbox), preSelectedValues: preSelectedNonCertifiableRoles, isLoading: true, hidden: true }])
const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);
export const DistributionListTitle = "Distribution List";

export const DistributionListSearchConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'distributionListSearch',
    body: {
        [FieldNames['SpinId']]: '',
        [FieldNames.Area]: "",
        [FieldNames.DealerNumber]: "",
        [FieldNames.Certification]: "",
        [FieldNames.IsPc]: "",
        [FieldNames.JobRole]: "",
        [FieldNames.ElevateNewsletter]: "",
        [FieldNames.CertifiableRoles]: "",
        [FieldNames.NonCertifiableRoles]: ""
    }
}

export const DistributionListExportConfig:SearchConfig = {
    method:FETCH_METHODS['Post'],
    path:'getSignedUrl',
    body:{
        bucketName:'',
        key: '',
        type: 'Download'
    }
}

export const DistributionListTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "SPIN ID", fieldKey: 'spinId' },
        { label: "NAME", fieldKey: "name" },
        { label: "DEALER", fieldKey: "dealer" },
        { label: "AREA", fieldKey: "area" },
        { label: "DISTRICT", fieldKey: "dist" },
        { label: "EMAIL", fieldKey: "USER_EMAIL",isNotCamelCase:true },
        { label: "PRIMARY JOB ROLE(s)", fieldKey: "primaryjob" },
        { label: "SECONDARY JOB ROLE(s)", fieldKey: "secondaryjob" }
    ],
    exportConfig: {
        fileName: 'Distribution List',
        exportMessage: "Distribution List Data",
        exportCritiria:true,
        schema:{
            spinId: "SPIN ID",
            name: "NAME",
            dealer: "DEALER",
            primaryjob: "PRIMARY JOB",
            secondaryjob: "SECONDARY JOB",
            area: "AREA",
            dist: "DISTRICT",
            USER_EMAIL: "USER EMAIL"
        }
    },
    serverSidePaginatation:true,
    breadcrums: [{ level: 1, name: DistributionListTitle }]
}

export const DistributionListFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: DistributionListSearchConfig,
    autoSearchOnLoad:true
}

export const DistributionListProps: Props = {
    isSearchVisible: true,
    showJobRoleContainer: true
}

export const DistributionListDynamicOptionFields: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['DealerNumber'], keyValuePair: { fieldLabel: 'DEALER_NAME', fieldValue: 'DEALER_CODE' } },
        { name: FieldNames['CertifiableRoles'], keyValuePair: { fieldLabel: 'JOB_DESCRIPTION', fieldValue: 'department' } },
        { name: FieldNames['NonCertifiableRoles'], keyValuePair: { fieldLabel: 'job_description', fieldValue: 'job_title' } }
    ],
    searchConfig: {
        method: FETCH_METHODS['Get'],
        path: 'distributionListDropdown',
    }
}